import React, { Component } from "react";
import "./Layout.css";
import { Navbar } from "reactstrap";
import Copyright from "../Copyright/Copyright";

class LayoutAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			searchArray: [],
			currentCases: [],
			sortValue: "",
			sortOrder: "",
			isAdminToken: localStorage.getItem("isAdminToken"),
			typeValue: "CaseManagement"
		};

		this.logout = this.logout.bind(this);
		this.goToCases = this.goToCases.bind(this);
		this.handleSelection = this.handleSelection.bind(this);
	}
	componentWillMount() {
		this.setState({ isAdminToken: localStorage.getItem("isAdminToken") });
	}
	componentDidMount() {
		let history = this.props.history;
		history.listen((location, action) => {
			if (location.pathname.indexOf("/cases/") !== -1) {
			this.setState({ typeValue: "admin" });
			}
			this.dropdownChange();
		});
		this.dropdownChange();
	}

	dropdownChange = () => {
		if (
			window.location.pathname.indexOf("/CaseManagement") === -1 ||
			window.location.pathname.indexOf("/ManagingPurchases") === -1 ||
			window.location.pathname.indexOf("/CustomCaseManagement") === -1 ||
			window.location.pathname.indexOf("/DandOManagement") === -1 ||
			window.location.pathname.indexOf("/SettlementRatesManagement") === -1
		) {
			this.setState({ typeValue: "admin" });
		}

		if (window.location.pathname.indexOf("/CustomCaseManagement") !== -1) {
			this.setState({ typeValue: "CustomCaseManagement" });
		}
		if (window.location.pathname.indexOf("/ManagingPurchases") !== -1) {
			this.setState({ typeValue: "ManagingPurchases" });
		}

		if (window.location.pathname.indexOf("/CaseManagement") !== -1) {
			this.setState({ typeValue: "CaseManagement" });
		}

		if (window.location.pathname.indexOf("/DandOManagement") !== -1) {
			this.setState({ typeValue: "DandOManagement" });
		}

		if (window.location.pathname.indexOf("/SettlementRatesManagement") !== -1) {
			this.setState({ typeValue: "SettlementRatesManagement" });
		}
		if (window.location.pathname.indexOf("/AceAlertsManagement") !== -1) {
			this.setState({ typeValue: "AceAlertsManagement" });
		}
	};

	logout = props => {
		localStorage.removeItem("searchValue");
		localStorage.removeItem("sortParams");
		localStorage.removeItem("isAdminToken");
		localStorage.removeItem("detailsPageUrl");
		sessionStorage.removeItem('tempSearchValue')
		this.props.keycloak.logout({ redirectUri: window.location.origin });
	};
	handleSelection = (evt, val) => {
		this.setState({ typeValue: evt.target.value });
		localStorage.removeItem("searchValue");
		localStorage.removeItem("sortParams");
		localStorage.removeItem("detailsPageUrl");
		sessionStorage.removeItem('tempSearchValue')
		if (
			evt.target.value === "ManagingPurchases" ||
			evt.target.value === "CaseManagement" ||
			evt.target.value === "CustomCaseManagement" ||
			evt.target.value === "DandOManagement"||
			evt.target.value === "SettlementRatesManagement" ||
			evt.target.value === "AceAlertsManagement"
		) {
			this.props.history.push("/" + evt.target.value);
			window.location.reload(false)
		}
	};
	
	goToCases = () => {
		localStorage.removeItem("searchValue");
		localStorage.removeItem("sortParams");
		localStorage.removeItem("detailsPageUrl");
		sessionStorage.removeItem('tempSearchValue')
		this.setState({ typeValue: "admin" });
		this.props.history.push("/cases");
		window.location.reload(false)
	};
	goToCaseManagement = () => {
		this.props.history.push("/CaseManagement");
		localStorage.removeItem("detailsPageUrl");
		this.setState({ typeValue: "CaseManagement" });
	};

	goToDandOManagement = () => {
		this.props.history.push("/DandOManagement");
		localStorage.removeItem("detailsPageUrl");
		this.setState({ typeValue: "DandOManagement" });
	};

	goToSettlementRatesManagement = () => {
		this.props.history.push("/SettlementRatesManagement");
		localStorage.removeItem("detailsPageUrl");
		this.setState({ typeValue: "SettlementRatesManagement" });
	};
	render() {
		return (
			<React.Fragment>
			<Navbar className={"NavBar"}>
				<div
				style={{ cursor: "pointer" }}
				onClick={() => this.goToCaseManagement()}
				>
				<img src="/SAR-Logo-White.png" className={"SARLogo"} alt="SAR" />
				</div>
				<div>
				<div className="relativePos displayInline">
					<select
					className="adminSelect"
					value={this.state.typeValue}
					onChange={evt => {
						this.handleSelection(evt, "value");
					}}
					>
					<option value="admin" disabled>
						Admin
					</option>
					<option value="CaseManagement">SCA Database Management</option>
					<option value="CustomCaseManagement">
						Custom Severity Management
					</option>
					<option value="DandOManagement">
						Risk Tool Management
					</option>
					<option value="AceAlertsManagement">
						ACE Alert&reg; Management
					</option>
					<option value="ManagingPurchases">Purchase Management</option>
					<option value="SettlementRatesManagement">Settlement Rate Management</option>
					</select>
				</div>
				<div
					id={"logout-link"}
					className={"NavNavigation displayInline"}
					onClick={() => this.goToCases()}
				>
					SCA Database
				</div>
				<div
					id={"logout-link"}
					className={"NavNavigation displayInline"}
					onClick={() => this.logout()}
				>
					Logout
				</div>
				</div>
			</Navbar>
			<div className={"NavDivider"} />
			<main className={"ContentAdmin"}>{this.props.children}</main>
			<div className={"Footer"}>
				<Copyright />
			</div>
			</React.Fragment>
		);
	}
}
export default LayoutAdmin;



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutAdmin.js